import { render } from "./VideoDisplay.vue?vue&type=template&id=97755eba"
import script from "./VideoDisplay.vue?vue&type=script&lang=js"
export * from "./VideoDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/SignSentence/SignSentence/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__